
























































import { Component, Mixins, Prop } from 'vue-property-decorator';
import axios from 'axios';

import generateSignedUrl from '@/helpers/generateSignedUrl';
import download from '@/helpers/download';
import copy from 'copy-to-clipboard';
import OfflineMixin from '@/mixins/OfflineMixin';

@Component({
  name: 'ReleaseNoteDownloadButton',
})
export default class extends Mixins(OfflineMixin) {
  @Prop() path!: string;
  @Prop() version!: string;
  @Prop() slug!: string;
  @Prop({ default: 'notes' }) type!: string

  isLoading = false;
  snackbar = false;

  get permalink() {
    return `${window.location.origin}/download/${this.slug}/${this.version}/${this.type}`;
  }

  copyPermalink(event: Event) {
    event.preventDefault();

    copy(this.permalink);
    this.snackbar = true;
  }

  get fileName(): string | null {
    const match = this.path.match(/([a-zA-Z0-9\s_\\.\-():])+(.pdf|.PDF)$/gm);
    return match ? match[0] : null;
  }

  get downloadUrl(): string {
    if (!this.path) {
      return '';
    }

    return generateSignedUrl(this.path);
  }

  public async download(): Promise<void> {
    if (this.downloadUrl === '') {
      return;
    }

    const token = await this.$auth.getTokenSilently({});
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    try {
      this.isLoading = true;

      const { data } = await axios.get(this.downloadUrl, { headers });

      download(data, this.path);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    } finally {
      this.isLoading = false;
    }
  }
}
